module.exports = __webpack_public_path__ + "media/images/pc/specials/common/benefit/benefit_chapel_studio-6b108804a60fbd26aec8b0427caa8acc.jpg";